import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "slider-wrapper" }
const _hoisted_2 = ["min", "max", "step", "value", "disabled", "aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}

import { ref, watchEffect } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
  modelValue: Number,
  min: { type: Number, default: 0 },
  max: { type: Number, default: 10000 },
  selectableMin: { type: Number, default: 1000 },
  step: { type: Number, default: 1 },
  readonly: { type: Boolean, default: false },
  ariaLabel: { type: String, default: "" }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const internalModelValue = ref<number>(props.modelValue);

const emit = __emit;

watchEffect(() => {
  internalModelValue.value = props.modelValue;
});

const updateModel = (event: Event) => {
  let value = (event.target as HTMLInputElement).valueAsNumber;

  if (value < props.selectableMin) {
    value = props.selectableMin;
  }

  emit('update:modelValue', value);
};

function onSliderChange() {
  emit("change", internalModelValue.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref: "slider",
      type: "range",
      min: props.min,
      max: props.max,
      step: props.step,
      value: internalModelValue.value,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (updateModel($event))),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (onSliderChange())),
      disabled: __props.readonly,
      orient: "vertical",
      "aria-label": __props.ariaLabel
    }, null, 40, _hoisted_2),
    (__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})